import React, { useState, useEffect } from 'react';
import { Joyride, EventData, STATUS, Step } from 'react-joyride';

const Walkthrough: React.FC = () => {
  const [run, setRun] = useState(false);

  useEffect(() => {
    // Only run the walkthrough if the user hasn't seen it yet.
    const hasSeenWalkthrough = localStorage.getItem('hasSeenWalkthrough');
    if (!hasSeenWalkthrough) {
      setRun(true);
    }

    const handleStartWalkthrough = () => {
      setRun(true);
    };

    window.addEventListener('start-walkthrough', handleStartWalkthrough);
    
    return () => {
      window.removeEventListener('start-walkthrough', handleStartWalkthrough);
    };
  }, []);

  const steps: Step[] = [
    {
      target: '#step-dashboard',
      content: 'Welcome to your Dashboard! Here you can get a quick overview of your key metrics.',
      skipBeacon: true,
    },
    {
      target: '#step-portfolio',
      content: 'Manage your portfolio items here. Add or edit past works.',
    },
    {
      target: '#step-services',
      content: 'Control and list the services you offer to clients.',
    },
    {
      target: '#step-bookings',
      content: 'View and manage all your incoming and past bookings.',
    },
    {
      target: '#step-chat',
      content: 'Communicate with clients directly through this chat module.',
    },
    {
      target: '#step-earnings',
      content: 'Track your earnings and financial performance over time.',
    },
    {
      target: '#step-discount',
      content: 'Create and distribute discounts or coupons to attract more clients.',
    },
    {
      target: '#step-ratings',
      content: 'Read what clients are saying about you and manage reviews.',
    },
    {
      target: '#step-support',
      content: 'Need help? Contact support or access our helpful resources here.',
    },
    {
      target: '#step-notifications',
      content: 'Stay updated! You will see alerts for new bookings and messages here.',
    },
    {
      target: '#step-profile',
      content: 'Access your profile settings, change your password, or log out.',
    },
  ];

  const handleJoyrideCallback = (data: EventData) => {
    const { status } = data;
    const finishedStatuses: string[] = [STATUS.FINISHED, STATUS.SKIPPED];

    if (finishedStatuses.includes(status)) {
      setRun(false);
      localStorage.setItem('hasSeenWalkthrough', 'true');
    }
  };

  return (
    <Joyride
      onEvent={handleJoyrideCallback}
      continuous
      run={run}
      scrollToFirstStep
      steps={steps}
      options={{
        zIndex: 10000,
        primaryColor: '#D3B88C', // Update to match Bouteek brand color if needed
        showProgress: true,
        buttons: ['back', 'close', 'primary', 'skip'],
      }}
    />
  );
};

export default Walkthrough;
